import { makeStyles } from '@material-ui/styles';

const formDisposition : any = {
    display: 'flex',
    flexDirection: 'column'
}

export default makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    modalBody: {
        ...formDisposition,
        backgroundColor: 'white',
        padding: 40,
        width: 500
    },

    modalTitle: {
        marginBottom: '3rem',
        display: 'inline-block'
    },

    modalForm: {
        ...formDisposition
    },

    modalTextField: {
        marginBottom: '2rem'
    }
});